// @vue/component
export const ContentContainer = {
	name: 'ContentContainer',
	template: `
		<div class="crm-messagesender-editor__content" data-role="content-container">
			<slot/>
		</div>
	`,
};
